import React, { Component } from 'react'
import { Row, Col, Table, Icon } from 'antd'
import DocsModel from '../models/DocsModel'
import AuthModel from '../models/AuthModel'
import moment from 'moment'

class AdminDocsView extends Component {

    constructor(props) {
        super(props)
        this.state = Object.assign({}, this.props.data)
    }

    componentWillReceiveProps(nextProps) {
        this.setState(nextProps.data)
    }

    loading() {
        var state = Object.assign({}, this.state)
        state.loading = true
        this.setState(state)
    }

    downloadAttach(record) {
        var attachBaseUrl = DocsModel.endpoint() + '/download'
        var url = attachBaseUrl+'/'+record.filename+'?token=' + AuthModel.getAuthToken() + '&id='+record.id
        DocsModel.download(record.descricao, url, record.mime)
    }

    render() {
        const columns = [
            {
                title: 'Nome do Ficheiro',
                dataIndex: 'filename',
                key: 'filename'
            },
            {
                title: 'Opções',
                key: 'action',
                render: (text, record) => (
                    <div>
                      <a role="button" onClick={(e) => this.downloadAttach(record)}>
                          <Icon type="download" style={{color: 'green'}} />
                      </a>
                    </div>
                )
            }
        ];
        var attachments = []
        if (this.state.filename) attachments.push({
            key: this.state.id, 
            id: this.state.id,
            filename: this.state.filename,
            mime: this.state.mime
        })
        
        return (
            <Row>
                <Col span={24}>
                    <Row>
                        <Col xs={24} sm={6}></Col>
                        <Col xs={24} sm={14}>
                            <legend>Documento</legend>

                            <table style={{textAlign: 'left', verticalAlign: 'top'}}>
                                <tbody>
                                    <tr>
                                        <th>ID</th><td>{this.props.data.id}</td>
                                    </tr>
                                    <tr>
                                        <th>Tipo</th><td>{this.props.data.label}</td>
                                    </tr>
                                    <tr>
                                        <th>Data</th><td>{moment(this.props.data.data).format('YYYY/MM/DD')}</td>
                                    </tr>
                                    <tr>
                                        <th>Criado por</th><td>{this.props.data.username}</td>
                                    </tr>
                                </tbody>
                            </table>

                            <hr />
                            <legend>Descrição</legend>

                            <p>{ this.props.data.description }</p>

                            <hr />
                            <div id="attachments">
                                <legend>Ficheiro</legend>
                                <Table dataSource={attachments} columns={columns} />
                            </div>

                        </Col>
                    </Row>

                </Col>
            </Row>
        )
    }
}

export default AdminDocsView;



// WEBPACK FOOTER //
// ./src/components/AdminDocsView.js